module.exports = __webpack_public_path__ + "static/dev_36-3a94f940a542a6f065acf53608524634.png";